import { buildPlatformScope, type PlatformScope } from '@examflow/core';

export interface ExamSessionScopeFields {
  languageId?: string | null;
  locale?: string | null;
  ttsLocale?: string | null;
  platformScope?: PlatformScope | null;
}

export function buildExamSessionScopeFields(
  examType: string | null | undefined,
  fallback: ExamSessionScopeFields | null = null
): Required<ExamSessionScopeFields> {
  const platformScope = buildPlatformScope({ examType });

  if (!platformScope) {
    return {
      languageId: fallback?.languageId ?? fallback?.platformScope?.languageId ?? null,
      locale: fallback?.locale ?? fallback?.platformScope?.locale ?? null,
      ttsLocale: fallback?.ttsLocale ?? fallback?.platformScope?.ttsLocale ?? null,
      platformScope: fallback?.platformScope ?? null,
    };
  }

  return {
    languageId: platformScope.languageId,
    locale: platformScope.locale,
    ttsLocale: platformScope.ttsLocale,
    platformScope,
  };
}
